document.addEventListener('DOMContentLoaded', function () {
  // Alle Top-Level Links mit href="#" auswählen
  document.querySelectorAll('.site-nav__dropdown-link--top-level[href="#"]').forEach(function(link) {
    
    // href entfernen, damit Klick deaktiviert ist
    link.removeAttribute('href');

    // optional: Cursor und Screenreader verbessern
    link.style.cursor = 'default';
    link.setAttribute('aria-disabled', 'true');
  });
});
